export type PaymentState = {
  clientSecret: null | string;
  country: null | string;
};

export default {
  clientSecret: null,
  country: null
} as PaymentState;
